<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- 筛选区 + 统计，与表格拼接成整块白卡 -->
    <div class="filter-bar">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="权限" size="small">
          <el-select
            v-model="listQuery.role_id"
            placeholder="请选择"
            clearable
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" size="small">
          <el-input
            v-model="listQuery.u_phone"
            placeholder="请输入店长手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="item-search">
          <el-button type="primary" size="small" @click="handleSearch"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <div class="filter-meta">
        共 <span class="meta-num">{{ listQuery.total || 0 }}</span> 个用户
      </div>
    </div>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        :height="tableHeight"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="role_id" slot-scope="{ row }">
          <el-tag
            v-if="row.role_id === 0"
            type="danger"
            effect="dark"
            size="mini"
          >
            普通用户
          </el-tag>
          <el-tag
            v-else-if="row.role_id === 1"
            effect="dark"
            size="mini"
          >
            员工
          </el-tag>
          <el-tag v-else type="success" effect="dark" size="mini">
            店长
          </el-tag>
        </template>
        <template slot="disable" slot-scope="{ row }">
          <el-tag
            v-if="row.disable == 1"
            type="danger"
            effect="dark"
            size="mini"
          >
            禁用
          </el-tag>
          <el-tag v-else type="success" effect="dark" size="mini">
            正常
          </el-tag>
        </template>
        <!-- <template slot="state" slot-scope="scope">
           <FillingStatus :value="scope.row" />
        </template>
        <template slot="fillRate" slot-scope="scope">
          <Percentage :value="scope.row"></Percentage>
        </template> -->
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button
              size="mini"
              type="text"
              @click="handleDisable(row)"
              primary
              >{{ row.disable === 1 ? "启用" : "禁用" }}</el-button
            >
            <el-button size="mini" type="text" @click="handleEdit(row)" primary
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
              >删除</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>
    <!-- 弹窗表单 -->
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="dialogForm" label-width="80px">
        <el-form-item label="用户权限:">
          <el-select
            v-model="dialogForm.role_id"
            placeholder="请选择"
            style="width: 100%;"
            clearable
          >
            <div v-for="(item, index) in roleList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺ID">
          <el-input clearable v-model="dialogForm.store_id"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
import {
  selectUser,
  updateUser,
  deleteUser,
  // disableUser,
} from "@/services/mini/user";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab,
  },
  async created() {
    this.getListData();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      loading: false,
      /* 视口高度，用于计算表格自适应高度 */
      winHeight: window.innerHeight,
      listQuery: {
        pageNumber: 1,
        pageSize: 15,
        total: 0,
      },
      /* 表格数据 */
      tableData: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      roleList: [
        { id: "0", name: "普通用户" },
        { id: 1, name: "员工" },
        { id: 2, name: "店长" },
      ],
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    /* 表格高度：按实际行数收缩，数据少时不再留出大片空白 */
    tableHeight() {
      const rows = this.loading ? 10 : Math.max(this.tableData.length, 1);
      const need = 48 + rows * 50;
      const max = this.winHeight - 300;
      return `${Math.max(Math.min(need, max), 200)}px`;
    },
  },
  watch: {},
  methods: {
    handleResize() {
      this.winHeight = window.innerHeight;
    },
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.role_id = listQuery.role_id?.join(",") || "";
      this.loading = true;
      const { data, code, count } = await selectUser(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    /* 搜索按钮 */
    async handleSearch() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 禁用 */
    handleDisable(row) {
      this.$message({
        type: "error",
        message: "该功能正在更新!",
      });
      // this.$confirm(
      //   `确定${row.disable === 1 ? "启用" : "禁用"}手机号为"${
      //     row.phone
      //   }"的用户吗?`,
      //   "禁用",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   }
      // ).then((res) => {
      //   disableUser({ id: row.id, disable: row.disable === 1 ? 0 : 1 }).then(
      //     (res) => {
      //       if (res.code === 200) {
      //         this.getListData();
      //         this.$message({
      //           type: "success",
      //           message: "操作成功!",
      //         });
      //       }
      //     }
      //   );
      // });
    },
    /* 修改 */
    handleEdit(row) {
      console.log(row);
      this.dialogVisible = true;
      this.dialogName = "编辑用户";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 保存 */
    save() {
      if (this.dialogName === "编辑用户") {
        updateUser(this.dialogForm).then((res) => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
   
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
       
          deleteUser({ id: row.id }).then((res) => {
            console.log(res);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

/* 筛选区：白色圆角卡片上半部，与表格拼接成一整块白卡 */
.filter-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 36px 16px 32px;
  margin: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  /* 筛选项占满左侧，换行时整体仍对齐 */
  .filter-form {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .el-form-item {
    margin-right: 16px;
    margin-bottom: 8px;

    .el-input__inner {
      width: 200px;
    }
  }
  /* 搜索按钮无 label，单独上移一点与输入框视觉对齐 */
  .item-search {
    margin-top: -6px;
  }

  /* 右侧统计，填补右端空白、平衡一行视觉重心 */
  .filter-meta {
    flex-shrink: 0;
    padding-top: 6px;
    font-size: 13px;
    color: #8a94a6;

    .meta-num {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  margin: 0;
  padding: 0 16px 64px;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>
